import React from 'react';
import Chip from 'Chip';
import ChipEdit from 'ChipEdit';
import PropTypes from 'prop-types';
import '../reset.css';
import styles from './index.css';

import Header from '../../components/header/';
import Navigation from '../../components/navigation/';
import ContactUs from '../../components/contactus/';
import Footer from '../../components/footer/';

class Layout extends React.PureComponent {
    /**
     * 渲染网页布局
     */
    render() {
        /**
         * 组件分发数据
         */
        const { content } = this.props;

        const { header, navigation, footer, contactus } = content;

        return (
            <div>
                <Header content={header} />
                <Navigation content={navigation} current={11} />
                <div className={styles.bodyBox}>
                    <ContactUs content={contactus} />
                </div>
                <Footer content={footer} />
                <ChipEdit />
            </div>
        );
    }
}

/**
 * 定义组件属性类型
 * 类型以及是否需要
 * */
Layout.propTypes = { content: PropTypes.object };

/**
 * 定义组件默认属性
 * */
Layout.defaultProps = {};

export default Layout;
